import React from 'react';
import {
  makeStyles,
  Container,
  Grid,
  Typography,
  Box,
  fade,
  Button,
} from '@material-ui/core';
import { Router } from 'config/i18n';
import Image from 'next/image';
import howToStart from '../../public/imgs/commercial-host/how-to-start.webp';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    paddingBottom: theme.spacing(5),
  },
  title: {
    fontSize: theme.typography.pxToRem(22),
    marginBottom: theme.spacing(0),
    textAlign: 'center',
    fontFamily: theme.typography.fontFamilySecondary,
    fontWeight: 'bold',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(36),
      marginBottom: theme.spacing(2),
    },
  },
  subTitle: {
    color: theme.palette.grey[300],
    fontSize: theme.typography.pxToRem(18),
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(32),
      marginBottom: theme.spacing(6),
    },
  },
  textContainer: {
    borderLeft: `1px dashed ${theme.palette.grey[200]}`,
    marginLeft: theme.spacing(2.5),
    [theme.breakpoints.only('sm')]: {
      marginLeft: theme.spacing(1.5),
    },
  },
  stepContainer: {
    marginLeft: theme.spacing(-2.5),
    width: '85%',
    padding: theme.spacing(4.5, 0, 2),
    [theme.breakpoints.only('sm')]: {
      marginLeft: theme.spacing(-1.5),
      width: 'auto',
    },
  },
  stepNumber: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    color: theme.palette.primary.main,
    borderRadius: 10,
    boxShadow: `0 0 4px 0 ${fade(theme.palette.common.black, 0.15)}`,
    border: `3px solid ${theme.palette.primary.main}`,
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 'bold',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.only('sm')]: {
      fontSize: theme.typography.pxToRem(14),
      width: theme.spacing(3),
      height: theme.spacing(3),
      borderRadius: 3,
    },
  },
  stepDesc: {
    marginLeft: theme.spacing(2),
    letterSpacing: theme.typography.pxToRem(0.5),
    lineHeight: theme.typography.pxToRem(34),
    fontSize: theme.typography.pxToRem(22),
    [theme.breakpoints.only('sm')]: {
      fontSize: theme.typography.pxToRem(18),
      lineHeight: theme.typography.pxToRem(30),
    },
  },
  imgContainer: {
    height: theme.spacing(42.5),
    marginTop: theme.spacing(5.5),
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 20,
    [theme.breakpoints.up('lg')]: {
      height: '94%',
      marginTop: theme.spacing(4.5),
    },
    [theme.breakpoints.only('sm')]: {
      height: theme.spacing(20),
      marginTop: theme.spacing(2.75),
      borderRadius: 15,
    },
  },
  img: {
    minHeight: '100% !important',
    maxWidth: '100% !important',
    position: 'absolute !important',
    margin: '0 !important',
    height: 'auto !important',
    maxHeight: 'none !important',
    width: 'auto !important',
    [theme.breakpoints.up('lg')]: {
      height: '100% !important',
      right: '-15% !important',
      maxWidth: 'none !important',
      top: '0px !important',
      left: 'auto !important',
    },
  },
  getStartedBox: {
    marginTop: theme.spacing(12),
    textAlign: 'center',
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(4.5),
    },
  },
  getStarted: {
    boxShadow: 'none',
  },
}));

const HowToStart = ({ i18n }) => {
  const classes = useStyles();
  const steps = i18n('fe_how_to_start_component:steps', { returnObjects: true });
  const handleBtnClick = () => {
    Router.push('/user/vehicles');
  };
  return (
    <>
      <Container classes={{ root: classes.mainContainer }}>
        <Grid
          container
          justify="center"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={12} lg={8}>
            <Typography variant="h2" classes={{ root: classes.title }}>
              {i18n('fe_how_to_start_component:title')}
            </Typography>
            <Typography variant="h3" classes={{ root: classes.subTitle }}>
              {i18n('fe_how_to_start_component:sub_title')}
            </Typography>
            <Grid container alignItems="stretch" spacing={2}>
              <Grid item xs={12} lg={7}>
                <Box className={classes.textContainer}>
                  {steps && typeof steps === 'object' && steps.length > 0 && steps.map((step, index) => (
                    <Box className={classes.stepContainer} key={step.desc}>
                      <Grid
                        container
                        wrap="nowrap"
                        justify="flex-start"
                        alignItems="flex-start"
                      >
                        <Grid item>
                          <Box className={classes.stepNumber}>{index + 1}</Box>
                        </Grid>
                        <Grid item xs>
                          <Typography
                            variant="h3"
                            classes={{ root: classes.stepDesc }}
                          >
                            {step.desc}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
                </Box>
              </Grid>
              <Grid item xs={12} lg={5}>
                <Box className={classes.imgContainer}>
                  <Image
                    className={classes.img}
                    src={howToStart}
                    placeholder="blur"
                    alt={i18n('fe_how_to_start_component:title')}
                    layout="fill"
                    unoptimized
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box className={classes.getStartedBox}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleBtnClick}
            classes={{ root: classes.getStarted }}
          >
            {i18n('fe_commercial_host_banner_shared:sign_up')}
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default HowToStart;
